/**
 * smsConsent.ts — the single source of truth for the versioned TCPA SMS
 * disclosure text. The EXACT rendered string + version is stored server-side
 * in `notification_consent_events` on opt-in, from TWO independent flows
 * (SettingsNotifications' SMS section and the onboarding evening-digest
 * step's StepDigestOptIn) that both render it through the shared
 * `SmsConsentDisclosure` component and write to that same ledger under this
 * version. Previously each flow kept its own literal copy in sync by hand
 * via a comment ("MUST match ... exactly") — a real drift risk any time
 * either copy changed. Import from here instead of redeclaring the strings.
 *
 * v3 (2026-09, YAR-459): Twilio's RCS sender review asked the disclosure to
 * name the program as RECURRING reminders and digests and to list what the
 * messages are about. v2 rows in the ledger keep the older "text message
 * reminders about my family's tasks and events" sentence; the version is
 * what tells them apart.
 */
export const SMS_CONSENT_VERSION = 'v3';
export const SMS_CONSENT_TEXT =
  'I agree to receive recurring text message reminders and digests from Yaruta ' +
  "about my family's schedules, events, tasks, reminders, and items requiring review. " +
  'Message frequency varies. Message and data rates may apply. ' +
  'Reply STOP to opt out or HELP for help.';
